import { createTheme } from '@material-ui/core/styles'

declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    selected: Palette['primary']
    lightGray: string
    lightBackground: string
    lightBlue: string
    disabled: string
    active: string
    black: string
    strongBlue: string
    boxShadow: string
    svgColorPrimaryBlue: string
    svgColorSecondaryBlue: string
  }
  interface PaletteOptions {
    selected: PaletteOptions['primary']
    lightGray: string
    lightBlue: string
    lightBackground: string
    disabled: string
    active: string
    black: string
    strongBlue: string
    boxShadow: string
    svgColorPrimaryBlue: string
    svgColorSecondaryBlue: string
  }
}

declare module '@material-ui/core/styles/createTheme' {
  interface Theme {
    gradient: string
    gradientLighter: string
    gradientNew: string
  }
  interface ThemeOptions {
    gradient: string
    gradientLighter: string
    gradientNew: string
  }
}

export const theme = createTheme({
  typography: {
    htmlFontSize: 18,
    fontFamily: 'Noto Sans',
  },

  overrides: {
    MuiTableCell: {
      root: {
        padding: '2px 5px',
      },
    },
    MuiDialogTitle: {
      root: {
        padding: '4px 24px',
      },
    },
    MuiDrawer: {
      paper: {
        zIndex: 990,
      },
    },
  },
  gradient: 'linear-gradient(140deg, rgba(24, 47, 117, 1) 0%, rgba(36, 140, 215,1) 100%)',
  gradientLighter:
    'linear-gradient(140deg, rgba(24, 47, 117, 0.9) 0%, rgba(36, 140, 215, 0.9) 100%)',
  gradientNew: 'linear-gradient(45deg, #182F75 0%, #248CD7 70%)',

  palette: {
    primary: {
      main: '#013685',
      light: '#06419b',
    },
    secondary: {
      main: '#5C5C5C',
      dark: '#808080',
    },
    error: {
      main: '#DC3545',
    },
    selected: {
      main: '#ffe000',
    },
    // background: {
    //   default: '#fff',
    // },
    lightGray: '#0000008a',
    lightBackground: '#F9F9F9',
    lightBlue: '#CCD7E7',
    disabled: '#2125293c',
    active: '#0D71C3',
    black: '#212529',
    strongBlue: '#06419b',
    boxShadow: '0px 3px 5px 0px #00000030',
    svgColorPrimaryBlue:
      'brightness(0) saturate(100%) invert(12%) sepia(73%) saturate(3376%) hue-rotate(211deg) brightness(95%) contrast(99%);',
    svgColorSecondaryBlue:
      'brightness(0) saturate(100%) invert(36%) sepia(61%) saturate(5721%) hue-rotate(180deg) brightness(86%) contrast(91%)',
  },
})
